export default "__VITE_ASSET__ccbd0c9c__"